import {ReactNode} from 'react';

import {WizardStepContext} from './WizardStepContext';

export interface StepBoundaryProps {
  id: string;
  children?: ReactNode;
}

export function StepBoundary(props: StepBoundaryProps) {
  return <WizardStepContext.Provider value={props.id}>{props.children}</WizardStepContext.Provider>;
}
